import { DefineDateTimeFormat } from "vue-i18n";

const defaultFormats: DefineDateTimeFormat = {
  shortDate: {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  },
  longDate: {
    year: "numeric",
    month: "short",
    day: "numeric",
    weekday: "short"
  },
  shortDateTime: {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric"
  },
  shortDateTimeWithSeconds: {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  shortDateTimeWithSeconds24: {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false
  },
  longDateTime: {
    year: "numeric",
    month: "short",
    day: "numeric",
    weekday: "short",
    hour: "numeric",
    minute: "numeric"
  },
  short24HourFormat: {
    hour12: false,
    hour: "numeric",
    minute: "numeric"
  },
  shortTime: {
    hour: "numeric",
    minute: "numeric"
  },
  time: {
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  longDateWithWeekDay: {
    day: "numeric",
    month: "long",
    weekday: "long",
    year: "numeric"
  }
};

const de = {
  de: defaultFormats
};

const en = {
  en: defaultFormats
};

const fr = {
  fr: defaultFormats
};

export default {
  ...de,
  ...en,
  ...fr
};
